/* HOGG Design Studio — cart guard. customhoggtumblers.com theme asset, loaded on EVERY page.
 *
 * Each Design Studio design is its own tumbler line (hidden `_design_ref`), carrying the
 * Customization variant it needs (`_fee_variant`). Designs needing the same fee share ONE
 * `Customization` line (`_studio_fee`), whose quantity should be the total of those tumblers.
 * Shopify treats the lines as unrelated, so a customer changing a tumbler's quantity — on the
 * cart page or in the drawer — would leave the fee behind. After any cart change this puts it
 * back in step, per fee variant:
 *   - the fee line's quantity = the total of the tumblers needing it (0 removes it)
 *   - fee removed while tumblers need it -> put back
 *   - several lines of one fee (an older cart) -> folded into one
 *   - an AI Design Package line goes with its design
 * then reloads so whatever the theme is showing matches. The order sync still treats the
 * tumbler line as the truth and flags a short fee, so this is a courtesy, not the safeguard.
 *
 * Watches fetch and XHR (both are used by themes and apps for cart edits), and checks once on
 * load, which covers the classic cart page's form submit. Needs no configuration.
 *
 * Theme: in layout/theme.liquid, before </body>:
 *   <script src="{{ 'studio-cart-guard.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';
  if (window.__hoggStudioCartGuard) return;
  window.__hoggStudioCartGuard = true;

  var REF = '_design_ref';
  var nativeFetch = window.fetch.bind(window);
  var busy = false, timer = null;

  function isCartChange(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }
  function schedule() {
    if (busy) return;
    clearTimeout(timer);
    timer = setTimeout(check, 200);
  }

  window.fetch = function (input) {
    var p = nativeFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url);
      if (isCartChange(url)) p.then(schedule, function () {});
    } catch (e) { /* never break the page's own fetch */ }
    return p;
  };
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartChange(url)) this.addEventListener('load', schedule);
    return open.apply(this, arguments);
  };

  function post(path, body) {
    return nativeFetch(path, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify(body)
    });
  }

  function isFee(it) {
    return /^customization/i.test(it.product_title || it.title || '');
  }

  function check() {
    if (busy) return;
    nativeFetch('/cart.js', {headers: {'Accept': 'application/json'}})
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        // Studio tumblers (one line per design) and what each needs: its fee variant.
        var need = {}, refs = {};
        items.forEach(function (it) {
          var p = it.properties || {};
          if (!p[REF] || p._ai_package || isFee(it)) return;
          refs[p[REF]] = true;
          if (p._fee_variant) need[p._fee_variant] = (need[p._fee_variant] || 0) + it.quantity;
        });
        // Studio fee lines, by variant: `_studio_fee` now; `_design_ref` on carts from before
        // the fee was merged into one line per variant.
        var have = {};
        items.forEach(function (it) {
          var p = it.properties || {};
          if (!isFee(it) || !(p._studio_fee || p[REF])) return;
          var v = String(it.variant_id);
          (have[v] = have[v] || []).push(it);
        });

        var updates = {}, readd = [], variants = {};
        Object.keys(need).concat(Object.keys(have)).forEach(function (v) { variants[v] = true; });
        Object.keys(variants).forEach(function (v) {
          var want = need[v] || 0, lines = have[v] || [];
          if (!lines.length) {
            if (want > 0) readd.push({id: Number(v), quantity: want, properties: {_studio_fee: '1'}});
            return;
          }
          // One line per fee variant, holding the total — any extra lines are folded away.
          if (lines[0].quantity !== want) updates[lines[0].key] = want;
          lines.slice(1).forEach(function (l) { updates[l.key] = 0; });
        });
        // An AI package line goes with its design.
        items.forEach(function (it) {
          var p = it.properties || {};
          if (p._ai_package && !refs[p[REF]]) updates[it.key] = 0;
        });
        if (!Object.keys(updates).length && !readd.length) return;

        busy = true;
        var chain = Promise.resolve();
        if (Object.keys(updates).length) chain = chain.then(function () { return post('/cart/update.js', {updates: updates}); });
        if (readd.length) chain = chain.then(function () { return post('/cart/add.js', {items: readd}); });
        return chain.then(function () { window.location.reload(); },
                          function () { busy = false; });
      })
      .catch(function () { busy = false; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
